import * as React from "react";
import { Box, Grid } from "@material-ui/core";
import { SvgIcon } from "../../../../components";
import { themeVariables } from "../../MUI";
import { tl } from "../../../../utils";

import * as styles from "./styles.scss";

interface IProps {
  total: number;
  tasks: number;
  tests: number;
  disabled?: boolean;
}

export const CourseCardLessons = (props: IProps) => {
  const textColor = themeVariables.palette.grey[props.disabled ? 500 : 50];

  return (
    <Box p={1.5} pb={0} className={styles.cardLessonsWrap}>
      <Grid container justifyContent="space-between" wrap="nowrap">
        <Box
          clone
          color={textColor}
          borderColor={themeVariables.palette.border}
        >
          <Grid item className={styles.cardLessons}>
            <Box clone mr={0.5}>
              <SvgIcon
                type={`courses-lesson-dark ${props.disabled ? "disabled" : ""}`}
              />
            </Box>
            {props.total}
          </Grid>
        </Box>
        {props.tasks ? (
          <Box
            clone
            color={textColor}
            borderColor={themeVariables.palette.border}
          >
            <Grid item className={styles.cardLessons}>
              <Box clone mr={0.5}>
                <SvgIcon
                  type={`courses-lessons-task-dark ${
                    props.disabled ? "disabled" : ""
                  }`}
                />
              </Box>
              {props.tasks}
            </Grid>
          </Box>
        ) : null}
        {props.tests ? (
          <Box
            clone
            color={textColor}
            borderColor={themeVariables.palette.border}
          >
            <Grid item className={styles.cardLessons}>
              <Box clone mr={0.5}>
                <SvgIcon
                  type={`courses-test-dark ${props.disabled ? "disabled" : ""}`}
                />
              </Box>
              {props.tests}
            </Grid>
          </Box>
        ) : null}
        {!props.tasks || !props.tests ? (
          <Box clone minWidth={30}>
            <Grid item />
          </Box>
        ) : null}
      </Grid>
    </Box>
  );
};
